import type { ReactNode } from 'react';
import { Redirect } from 'wouter';
import { useAuth, type Role } from '../lib/AuthContext';
export function RoleGuard({ roles, children }: { roles: Role[]; children: ReactNode }) { const { user } = useAuth(); return user && roles.some((role) => user.roles.includes(role)) ? children : <Redirect to="/" />; }
